<template>
  <div>
    <banner />
    <search-content />
    <search-footer />
  </div>
</template>

<script>
import banner from './banner'
import searchContent from './content'
import searchFooter from './footer'

export default {
  components: {
    banner,
    searchContent,
    searchFooter
  },
  created() {
  },
  methods: {
    onClick() {
      this.$router.push('/profile');
    }
  }
}
</script>

<style lang="less" scoped>
h1 {
  font-size: 1rem;
  padding: 20px;
  text-align: center;
}
</style>
